import { RCCIcon } from "react-common-components";
import styled, { css, keyframes } from "styled-components";

export const Container = styled.header`
  width: 100%;

  height: 42px;
  min-height: 42px;
  
  z-index: 204;
  margin-bottom: 0.5rem;
  box-shadow: rgb(0 0 0 / 20%) 0px 2px 5px;

  background: var(--header-color);
  color: var(--default-color-font);
  border-bottom: 1px solid var(--border-color);

  @media print{
    display: none;
  }
`;

export const NavbarContainer = styled.div``;

export const NavbarHeader = styled.div`
    display: inline-block;
    margin-bottom: 15px;
    height: 0;
    margin-left: 0;
    margin-right: 0; 
    @media(max-width: 600px){
        display: none;
    }

    button{
        margin: 4px 0;
        border: 1px solid transparent;
        width: 40px;
        height: 35px;
        line-height: 0;
        padding: 0 0 1px;
        text-align: center;
        z-index: 1;
        float: left;
        background: transparent;
        transition: 300ms;
        &:hover{
            svg{
                opacity: 0.8;
            }   
        }
        svg{
            transition: 300ms;
            color: var(--default-color-font);
        }
    }

    span.company-name{
        color: var(--default-color-font);
        text-shadow: none;
        height: 42px;
        float: left;
        padding: 10px 15px;
        font-size: 16px;
        user-select: none;
        color: var(--default-color-font); 
    }

    img.company-img-header{
        height: 42px;
        vertical-align: middle;
        margin-left: 4px;
        @media(max-width: 700px){
            display:none;
        }
    }

`;

const ringingBell = keyframes`
  0% { transform: rotate(0); }
  1% { transform: rotate(30deg); }
  3% { transform: rotate(-28deg); }
  5% { transform: rotate(34deg); }
  7% { transform: rotate(-32deg); }
  9% { transform: rotate(30deg); }
  11% { transform: rotate(-28deg); }
  13% { transform: rotate(26deg); }
  15% { transform: rotate(-24deg); }
  17% { transform: rotate(22deg); }
  19% { transform: rotate(-20deg); }
  21% { transform: rotate(18deg); }
  23% { transform: rotate(-16deg); }
  25% { transform: rotate(14deg); }
  27% { transform: rotate(-12deg); }
  29% { transform: rotate(10deg); }
  31% { transform: rotate(-8deg); }
  33% { transform: rotate(6deg); }
  35% { transform: rotate(-4deg); }
  37% { transform: rotate(2deg); }
  39% { transform: rotate(-1deg); }
  41% { transform: rotate(1deg); }

  43% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;

export const NavbarButtons = styled.div`
    height: 0;
    float: right;

    >ul{
        border: 0;
        background-color: transparent;
        height: 100%;
        margin: 0;
        padding-left: 0;
        list-style: none;
        >li.navbar-buttons-li{
            border-left: 0 solid transparent;
            height: 42px;
            padding: 0;
            position: relative;
            float: left;
            display: flex;
            a.buttons-toggle, button.buttons-toggle{
                border: none;
                background: transparent;
                color: var(--default-color-font);

                display: flex;
                align-items: center;
                justify-content:center;

                line-height: inherit;
                text-align: center;
                height: 100%;
                width: auto;
                min-width: 2.75rem;
                padding: 0;
                margin: 0;
                position: relative;
                cursor: pointer;
                transition: 300ms ease;

                &:hover{
                    opacity: 0.8;
                }
                >svg{
                    transition: 300ms;
                    padding-left: 3px;
                    padding-right: 3px;
                    text-align: center; 
                }
                >span.company-name{
                    max-width: 37rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: pointer;
                    font-size: 0.8rem;
                    user-select: none;
                }
                >div.notifications-number{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    border-radius: 50%;
                    background: var(--purple);
                    color: #FFF;
                    width: 14px;
                    height: 14px;
                    font-size: 0.6rem;
                    user-select: none;
                }
                &.animate-ringing{
                    >svg{
                        animation: ${ringingBell} 4s .7s ease-in-out infinite;
                    }
                }
            }

            @media(max-width: 600px){
                &:first-child{
                    a.buttons-toggle, button.buttons-toggle{
                        >span.company-name{
                            max-width: 12rem;
                        }
                    }
                }
            }

            @media(max-width: 440px){
                &:first-child{
                    a.buttons-toggle, button.buttons-toggle{
                        >span.company-name{
                            max-width: 6rem;
                        }
                    }
                }
            }

            @media(max-width: 370px){
                &:first-child{
                    a.buttons-toggle, button.buttons-toggle{
                        >span.company-name{
                            max-width: 4rem;
                        }
                    }
                }
            }

            @media(max-width: 344px){
                &:first-child{
                    a.buttons-toggle, button.buttons-toggle{
                        >span.company-name{
                            max-width: 2rem;
                        }
                    }
                }
            }

            @media(max-width: 318px){
                &:first-child{
                    a.buttons-toggle, button.buttons-toggle{
                        >span.company-name{
                            display: none;
                        }
                    }
                }
            }
        }
    }
`;


export const MenuDropdownRight = styled.ul`
    position: absolute;

    top: 100%;
    right: 2px;
    
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    background-color: var(--input-background-color);
    color: var(--default-color-font);
    border: 1px solid rgba(0,0,0,0.2);
    background-clip: padding-box;

    box-shadow: 2px 2px 3px 3px rgba(0, 0, 0, 0.2);

    width: 280px;
    @media (max-width: 350px){
        width: 250px;
    }
    @media (max-width: 300px){
        width: 200px;
    }
`;

export const DivBusinessGroup = styled.div`
    padding: 0 10px;
    margin: 16px 0;
    >div.not-active{
        display: flex;
        flex-direction: row;
        align-items: center;
        color: var(--grey);
        margin-bottom: -10px;
        >svg{
            margin-right: 10px;
        }
    }
`;

export const DivCompany = styled.div`
    padding: 0 10px;
    border-bottom: 1px solid var(--border-color);

   >div.not-active{
        display: flex;
        flex-direction: row;
        align-items: center;
        color: var(--grey);
        margin: 16px 0;
        svg{
            margin-right: 10px;
        }
    } 

    >ul.company-change{
        max-height: 160px;
        overflow-y: auto;  

        display: block;
        padding: 5px 0;
        margin: -8px 0 0;
        font-size: 14px;      
    }

`;

interface ILiCompanyChange {
    isSelected?: boolean;
}

export const LiCompanyChange = styled.li<ILiCompanyChange>`
    line-height: 1.5;
    width: 100%;
    color: var(--default-color-font);



    >a.button-company-change, 
    >button.button-company-change{
        border:none;
        font-size: 13px;
        margin: 1px 0;

        display: flex;
        align-content: flex-start;
        align-items: center;

        padding: 3px 10px;
        font-weight: normal;
        line-height: 1.42857143;
        color: var(--default-color-font);

        background: transparent;
        width: 100%;
        text-align: left;
        transition: 300ms;

        >span{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;   
        }

        >svg{
            color: var(--default-color-font);
            margin-right: 10px;
            transition: 300ms;
        }
        &:hover{
            background: var(--main-color);
            color: #FFF;
            >svg{
                color: #FFF;
            }
        }
    }

    ${(props) => props.isSelected && css`
        background-color: var(--grey);
        >a.button-company-change, 
        >button.button-company-change{
            color: var(--default-color-font);
            >svg{
                color: var(--default-color-font);
            }
        }
    `}
`;

export const StyledIcon = styled(RCCIcon)`
    display: none;

    height: 42px;
    vertical-align: middle;
    margin-left: 4px;

    transition: 200ms ease;
    &:hover{
        opacity: 0.75;
        cursor: pointer;
    }

    @media(max-width: 800px){
        display: initial;
    }
`;
